import { render, staticRenderFns } from "./ApplicationExpired.vue?vue&type=template&id=005fa2f1&scoped=true&"
import script from "./ApplicationExpired.vue?vue&type=script&lang=js&"
export * from "./ApplicationExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005fa2f1",
  null
  
)

export default component.exports